export interface VehicleProvenanceUpdateDTO {
  odometer?: number;
  scrapped?: boolean;
  stolen?: boolean;
  finance?: boolean;
}
